import React from 'react';
import { RoomStageInfo } from '../../common/types';

export type RoomStageProgressProps = {
  stages: RoomStageInfo[];
};

export function RoomStageProgress(props: RoomStageProgressProps) {
  const { stages } = props;

  return (
    <div className="mb-2">
      <div className="flex justify-between items-end flex-wrap overflow-hidden">
        {stages.map((stage, index) => {
          // Determine the ball color based on stage progress
          let ballColor = 'bg-gray-500'; // Default: not started
          if (stage.completedAt) {
            ballColor = 'bg-blue-700'; // Completed
          } else if (stage.startedAt) {
            ballColor = 'bg-blue-500'; // Started
          }

          return (
            <div
              key={stage.stageUuid}
              className="flex flex-col items-center justify-end h-full w-16 max-w-16 mb-4"
            >
              {/* Stage node with hover tooltip for the stage name */}
              <div
                className={`rounded-full flex items-center justify-center text-white font-bold w-12 h-12 ${ballColor}`}
                title={`Stage #${stage.number} ${stage.name} ${
                  stage.completedAt
                    ? '- Completed'
                    : stage.startedAt
                    ? '- In Progress'
                    : '- Not Started'
                }`} // Stage name on hover
              >
                {/* Optional: You can add a number or symbol here */}
              </div>

              {/* Visual representation of puzzles */}
              <div className="flex space-x-1 mt-2">
                {/* show color based on completion */}
                {stage.puzzles.map((puzzle, i) => (
                  <div
                    key={puzzle.puzzleUuid}
                    className={`w-3 h-3 rounded-full ${
                      puzzle.completedAt ? 'bg-blue-300' : 'bg-gray-600'
                    }`}
                    title={`Puzzle #${stage.number}.${puzzle.number} ${
                      puzzle.completedAt ? '- Solved' : '- Unsolved'
                    }`} // Stage name on hover
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
